module.exports = __webpack_public_path__ + "img/检测2.2b7192d7.jpg";